import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Tools } from "./tools";
import { ITranslation } from "./translation.interface";

@Pipe({
  name: "translationValue",
  standalone: true,
  pure: false,
})
export class TranslationValuePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(translation: ITranslation | undefined | null, fallback = ""): string {
    if (!translation) {
      return fallback;
    }

    const lang = this.translateService.currentLang as keyof ITranslation;
    return Tools.getTranslation(translation, lang, fallback);
  }
}
